module.exports = __webpack_public_path__ + "img/emoji-worried-80x80.fe51caab.png";